import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

const AUTH_ENDPOINTS_TO_IGNORE = [
  '/api/auth/signin',
  '/api/auth/login',
  '/api/auth/signup',
  '/api/auth/forgot-password',
  '/auth/signin',
  '/auth/login',
  '/auth/signup',
  '/auth/forgot-password',
];

export const unauthorizedInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const requestUrl = req.url.toLowerCase();

  return next(req).pipe(
    catchError((error: unknown) => {
      if (!(error instanceof HttpErrorResponse) || error.status !== 401) {
        return throwError(() => error);
      }

      const shouldIgnoreAuthEndpoint = AUTH_ENDPOINTS_TO_IGNORE.some((endpoint) =>
        requestUrl.includes(endpoint)
      );
      const isOnAuthRoute =
        typeof window !== 'undefined' && window.location.pathname.toLowerCase().startsWith('/auth');

      /**
       * Qualquer 401 em rota autenticada deve encerrar sessão e ir ao login.
       * Ignorar só tentativas explícitas em /auth/* (credenciais inválidas) e páginas /auth.
       * Não ignorar memberships/sidebar/projects: com token expirado isso impedia o logout e gerava loop de pedidos.
       */
      if (!shouldIgnoreAuthEndpoint && !isOnAuthRoute) {
        auth.logout();
      }

      return throwError(() => error);
    })
  );
};
